import React from 'react';
import Button from '@material-ui/core/Button';
import Loading from '../../loading';
import $ from "jquery";
import Server from '../../../functions/server';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class PendingPayment extends React.Component {

  state = {
    data: [],
    fullWidth: true,
    maxWidth: 'lg'
  }


  getPendingPayments = () => {
    let context = this;
    let customerId = this.props.customerId;
    let closingbalance = this.props.getClosingbalance;
    try {
      closingbalance = Number(closingbalance);
    } catch (e) {
    }
    context.setState({ load: true, message: 'Getting Pending Payment Invoice!!!!' })
    $.ajax({
      type: 'POST',
      data: { 'customer_id': customerId },
      url: Server() + 'statement/pendingpayment.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          data.map((x) => {
            let amount = x.total;
            try {
              amount = Number(amount);
            } catch (e) {
            }
            if (closingbalance == 0) {
              x.value = 'Paid';
              x.balance = 0;
            }
            else {
              if (closingbalance > amount) {
                closingbalance = closingbalance - amount;
                x.value = 'Un Paid';
                x.balance = amount;
              }
              else {
                x.value = 'Un Paid';
                x.balance = amount - (amount - closingbalance);
                closingbalance = 0;
              }
            }
          })
          context.setState({ data: data, dialog: true })
        } catch (e) {

        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    let i = 1;
    let closingbalance = this.props.getClosingbalance;
    try {
      closingbalance = Number(closingbalance).toFixed(2);
    } catch (e) {
    }
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Button variant="outlined" color='primary' onClick={this.getPendingPayments}>Pending Payments</Button>
        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}  open={this.state.dialog}
          onClose={ () => { this.setState({ dialog: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Pending Payment</DialogTitle>
          <DialogContent>
            <table id='table' width='100%'>
              <tr>
                <th id='th'><center>Sino</center></th>
                <th id='th'><center>Invoice</center></th>
                <th id='th'><center>Total Amount</center></th>
                <th id='th'><center>Pending Amount</center></th>
              </tr>
              { this.state.data.map((d) => {
                  if (d.value == 'Un Paid') {
                    let total = Number(d.total).toFixed(2);
                    let balance = Number(d.balance).toFixed(2);
                    return (
                      <tr>
                        <td><center>{i++}</center></td>
                        <td><center>{d.invoice}</center></td>
                        <td><center>{total}</center></td>
                        <td><center>{balance}</center></td>
                      </tr>
                    )
                  }
                })
              }
            </table>
            <div align='right' style={{color: 'red', fontSize: 18}}>Closing Balance: {closingbalance}</div>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ dialog: false }) } }>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default PendingPayment;
